import React from "react";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";

const ImageUpload = (props) => {
  const maxSizeImage = 1000000;
  const toast = React.useRef(); // corregido: useRef()

  // Tipos permitidos
  const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];

  const customBase64Uploader = async (event) => {
    try {
      const file = event.files[0];

      // Validar tipo de archivo
      if (!allowedTypes.includes(file.type)) {
        throw new Error("Formato no permitido. Solo PNG, JPG o JPEG.");
      }

      // Validar tamaño
      if (file.size > maxSizeImage) {
        throw new Error("La imagen excede el tamaño máximo permitido.");
      }

      // Convertir a base64
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        props.setImage(reader.result);

        toast.current.show({
          severity: "success",
          summary: "Éxito",
          detail: "Imagen subida correctamente",
        });
      };
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.message,
      });
    }
  };

  const itemTemplate = (file, props) => {
    return (
      <div className="flex align-items-center flex-wrap">
        <div className="flex align-items-center" style={{ width: "40%" }}>
          <img
            alt={file.name}
            role="presentation"
            src={file.objectURL}
            width={100}
          />
          <span className="flex flex-column text-left ml-3">
            {file.name}
            <small>{new Date().toLocaleDateString()}</small>
          </span>
        </div>

        <Button
          type="button"
          icon="pi pi-times"
          className="p-button-outlined p-button-rounded p-button-danger ml-auto"
          onClick={() => onTemplateRemove(file, props.onRemove)}
        />
      </div>
    );
  };

  const onTemplateRemove = (file, callback) => {
    callback();
  };

  const emptyTemplate = () => {
    return (
      <div className="flex align-items-center flex-column">
        <span
          style={{ fontSize: "1.2em", color: "var(--text-color-secondary)" }}
          className="my-5"
        >
          {props.emptyText}
        </span>
      </div>
    );
  };

  return (
    <div>
      <Toast ref={toast} />

      <FileUpload
        name="image"
        accept="image/png, image/jpeg, image/jpg"   // <-- TIPOS PERMITIDOS
        maxFileSize={maxSizeImage}
        chooseLabel={props.chooseLabel}
        cancelLabel="Cancelar"
        uploadLabel="Subir"
        customUpload
        uploadHandler={customBase64Uploader}
        auto={props.auto}
        itemTemplate={itemTemplate}
        emptyTemplate={emptyTemplate}
      />
    </div>
  );
};

export default ImageUpload;
